import { render } from "./p-box-widget.vue?vue&type=template&id=3d17937e"
import script from "./p-box-widget.vue?vue&type=script&lang=js"
export * from "./p-box-widget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__